import { ICheckPayment, IPaymentsRes } from './../models/payments';
import axios from '../helpers/axios'
import { logError } from '../services';

export const getPaymentDetails = async (
  paymentType = 'Check',
  checkNumber: string,
  vendorId?: string
): Promise<ICheckPayment> => {
  try {
    const { data } = await axios.get(`/api/payments/${paymentType}/${checkNumber}`, {
      params: {
        vendorId
      }
    });
    return data;
  } catch (error) {
    logError(error, 'getPaymentDetails failed');
    return Promise.reject(error.response.data);
  }
};

export const getPayments = async (filters?: {
  query?: string;
  invoiceId?: string | number;
  vendorId?: string | number;
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
}): Promise<IPaymentsRes> => {
  try {
    const { data } = await axios.get(`/api/payments`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getPayments failed');
    return Promise.reject(error);
  }
};
